import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import { Credentials } from '../../model/credentials.model';
import { BehaviorSubject, Observable, of, Subject } from 'rxjs';
import * as CryptoJS from "crypto-js";
import {isPlatformBrowser} from "@angular/common";
import SecureStorage from 'secure-web-storage';
let SECRET_KEY = '1nv134t1sS!4852321!nv134t1sS';

@Injectable({
  providedIn: 'root',
})
export class CredentialsService {

  public secureStorage = new SecureStorage(localStorage, {
    hash: function hash(key: any) {
      key = CryptoJS.SHA256(key);
      key = CryptoJS.SHA256(SECRET_KEY);
      return key.toString();
    },
    encrypt: function encrypt(data: any) {
      data = CryptoJS.AES.encrypt(data, SECRET_KEY);

      data = data.toString();

      return data;
    },
    decrypt: function decrypt(data: any) {
      data = CryptoJS.AES.decrypt(data, SECRET_KEY);

      data = data.toString(CryptoJS.enc.Utf8);

      return data;
    },
  });

  public credentialsSubjet = new Subject<Credentials>();

  credentialsKey = 'credentials';
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  /**
   * Checks is the user is authenticated.
   * @return True if the user is authenticated.
   */
  isAuthenticated(): boolean {
    return !!this.credentials;
  }

  /**
   * Gets the user credentials.
   * @return The user credentials or null if the user is not authenticated.
   */
  get credentials(): Credentials | null {
    if (isPlatformBrowser(this.platformId)) {
      return this.secureStorage.getItem(this.credentialsKey);
    } else {
      return null;
    }
  }

  /**
   * Sets the user credentials.
   * The credentials may be persisted across sessions by setting the `remember` parameter to true.
   * Otherwise, the credentials are only persisted for the current session.
   * @param credentials The user credentials.
   * @param remember True to remember credentials across sessions.
   */
  setCredentials(
    credentials?: Credentials,
    remember?: boolean
  ): Observable<Credentials> {
    if (credentials) {
      this.secureStorage.setItem(
        this.credentialsKey,
        credentials
      );
    } else {
      this.secureStorage.clear();
    }
    if (credentials) {
      this.credentialsSubjet.next(credentials);
      return of(credentials);
    } else {
      const errorMessage = 'Credentials are undefined.';
      console.error(errorMessage);
      const defaultCredentials: Credentials = new Credentials(
        'anonymous',
        'anonymous',
      );
      return of(defaultCredentials);
    }
  }

  credentialsObservable(): Observable<Credentials> {
    return this.credentialsSubjet.asObservable();
  }

  hasAnyAuthority(authorities: string[] | string): boolean {
    if (
      !this.isAuthenticated() ||
      !this.credentials ||
      !this.credentials.authorities
    ) {
      return false;
    }

    if (!Array.isArray(authorities)) {
      authorities = [authorities];
    }


    // @ts-ignore
    return authorities.some((authority: string) => this.credentials.authorities.includes(authority)
    );
  }
  login = new BehaviorSubject([]);
  loginObservable = this.login.asObservable();

  sendCredentials(credentials: any) {
    this.login.next(credentials);
  }
}
